<template>
  <el-dialog
    title="修改题库"
    :visible.sync="dialogVisible"
    width="560px"
    :before-close="handleClose"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div style="padding: 10px 50px">
      <div>
        <span>题库名称：</span>
        <el-input
          size="small"
          style="width:80%"
          v-model.trim="requestData.questionBankName"
          placeholder="请输入题库名称"
        ></el-input>
      </div>
      <div style="margin-top: 10px;">
        <span>完成时间：</span>
        <el-input
          size="small"
          style="width:80%"
          v-model.trim="requestData.questionTime"
          placeholder="请输入完成时间"
          ><template slot="append">分钟</template></el-input
        >
      </div>
      <!-- <div class="question-type">
        <span>题库类型：</span>
        <el-radio
          size="mini"
          v-model="requestData.questionType"
          :label="1"
          border
          disabled
          >选择题</el-radio
        >
        <el-radio
          size="mini"
          v-model="requestData.questionType"
          :label="3"
          border
          disabled
          >判断题</el-radio
        >
      </div> -->
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="edit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "QuestionBankAdd",
  components: {},
  props: {
    editResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    questionBank: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      requestData: {
        questionBankId: "",
        questionBankName: "",
        questionFounder: JSON.parse(this.$store.state.userInfo).userName,
        questionTime: "",
        // questionType: 1
      }
    };
  },
  created() {},
  mounted() {},
  watch: {
    editResize: function(newVal, oldVal) {
      if (newVal) {
        this.dialogVisible = true;
        this.requestData.questionBankId = this.questionBank.questionBankId;
        this.requestData.questionBankName = this.questionBank.questionBankName;
        this.requestData.questionTime = this.questionBank.questionTime;
        // this.requestData.questionType = this.questionBank.questionType;
      }
    }
  },
  computed: {},
  methods: {
    handleClose() {
      this.requestData = {
        questionBankName: "",
        questionFounder: JSON.parse(this.$store.state.userInfo).userName,
        questionTime: "",
        // questionType: "1",
        schoolId: Number(this.$store.state.schoolId)
      };
      this.dialogVisible = false;
    },
    // 获取告知模板列表
    async edit() {
      if (this.requestData.questionBankName == "") {
        this.$message("请输入题库名称！");
        return;
      }
      if (!/(^[1-9]\d*$)/.test(this.requestData.questionTime)) {
        this.$message("请输入要求完成时间！");
        return;
      }
      let req = this.requestData;
      let res = await this.$Http.editQuestionBank(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "修改成功!"
        });
        this.handleClose();
        this.$emit("getList");
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.question-type {
  margin-top: 20px;
}
</style>
